export default {
  switchToMeaning: 'Zur Bedeutung wechseln',
};
